// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty-page>.text>.btn.secondary[data-v-dfbc30c8]{margin-top:0}", ""]);
// Exports
module.exports = exports;
